<template>
  <!-- Se c'è un errore da mostrare, usiamo b-form-group -->
  <!-- v-if="showErrorMessage" -->
  <b-form-group
    class="mb-0"
    :invalid-feedback="errorMessage"
    :state="computedState"
  >
    <b-form-input
      :id="id"
      class="shadow_6"
      type="text"
      :value="value"
      @input="onInput($event)"
      @beforeinput="handleNumericInput"
      @blur="hasBlurred = true"
      v-bind="inputAttrs"
      :placeholder="placeholder"
      :name="name"
      :state="handleMinState === null ? computedState : handleMinState"
    ></b-form-input>
  </b-form-group>
  <!-- Altrimenti, mostriamo solo l'input semplice -->
  <!-- <b-form-input
    v-else
    :id="id"
    class="shadow_6"
    type="text"
    :value="value"
    @input="onInput($event)"
    @beforeinput="handleNumericInput"
    @blur="hasBlurred = true"
    v-bind="inputAttrs"
    :placeholder="placeholder"
    :name="name"
    :state="computedState"
  ></b-form-input> -->
</template>

<script>
export default {
  name: "InputNumerico",
  // Disabilitiamo l'ereditarietà automatica degli attributi
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    // Questa prop viene passata dall'esterno con :required
    // Se domanda.r non è definita o non è true, non verrà applicato l'attributo
    required: {
      type: Boolean,
      default: undefined
    },
    // Se true, si permettono solo valori interi
    int: {
      type: Boolean,
      default: false
    },
    // Valore massimo ammesso
    max: {
      type: Number,
      default: null
    },
    // Valore minimo ammesso
    min: {
      type: Number,
      default: null
    },
    placeholder: {
      type: String,
      default: "..."
    },
    name: {
      type: String,
      default: ""
    },
    // Funzione di validazione esterna
    state: {
      type: Function,
      default: null
    },
    // Prop per controllare se mostrare sempre lo state
    alwaysShowState: {
      type: Boolean,
      default: false
    },
    // Prop per mostrare solo lo stato errato (non mostrare quello corretto/verde)
    showOnlyWrongState: {
      type: Boolean,
      default: true
    },
    // Messaggio di errore da mostrare quando lo stato è falso
    invalidFeedback: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      hasBlurred: false,
      minErrorMessage: ""
    }
  },
  computed: {
    // Determina se mostrare il messaggio di errore
    showErrorMessage() {
      return (
        this.computedState === false &&
        (this.alwaysShowState || this.hasBlurred)
      )
    },

    // Genera il messaggio di errore predefinito in base ai vincoli violati
    defaultErrorMessage() {
      // Gestisci il caso in cui this.value sia null o undefined
      if (this.value === null || this.value === undefined) {
        return this.required ? "Campo obbligatorio" : ""
      }

      // Gestisci il caso di stringa vuota
      if (this.value === "") {
        return this.required ? "Campo obbligatorio" : ""
      }

      // Converti in modo sicuro a stringa e poi a numero
      const numValue = Number((this.value + "").replace(",", "."))

      if (isNaN(numValue)) {
        return "Valore non valido"
      }

      if (this.min !== null && numValue < this.min) {
        return `Il valore deve essere almeno ${this.min}`
      }

      if (this.max !== null && numValue > this.max) {
        return `Il valore non può superare ${this.max}`
      }

      if (this.int && (this.value + "").includes(",")) {
        return "Inserire solo numeri interi"
      }

      return "Valore non valido"
    },

    // Messaggio di errore da mostrare, usa quello predefinito se non specificato
    errorMessage() {
      return (
        this.invalidFeedback || this.minErrorMessage || this.defaultErrorMessage
      )
    },

    // Se la prop required è definita ed è true, restituisce { required: true },
    // altrimenti non restituisce nulla (oggetto vuoto)
    requiredAttr() {
      return this.required === true ? { required: true } : {}
    },

    // Computed property che include gli attributi required, max e min solo se definiti
    inputAttrs() {
      const attrs = { ...this.requiredAttr }
      if (this.max !== null) {
        attrs.max = this.max
      }
      if (this.min !== null) {
        attrs.min = this.min
      }

      attrs.autocomplete = "off"

      return attrs
    },

    // Computed property per gestire lo state di validazione
    computedState() {
      // Se non c'è una funzione state, ritorna null
      if (!this.state) return null

      // Determina se mostrare lo stato di validazione in base alle props
      if (this.alwaysShowState || this.hasBlurred) {
        const validationResult = this.state(this.value)

        // Se showOnlyWrongState è true, mostra solo lo stato errato
        if (this.showOnlyWrongState) {
          // Mostra solo lo stato se è falso (errato/rosso)
          return validationResult === false ? false : null
        }

        // Altrimenti mostra il risultato completo della validazione
        return validationResult
      }

      // Se non è stato fatto blur o alwaysShowState è false, non mostrare nulla
      return null
    },
    handleMinState() {
      // Se la prop min è definita e non è null, restituisce true
      // altrimenti restituisce false
      return this.min !== null && this.hasBlurred
        ? this.value >= this.min
          ? null
          : false
        : null
    }
  },
  watch: {
    handleMinState(newValue) {
      if (newValue === false) {
        this.minErrorMessage = `Il valore deve essere almeno ${this.getMinWarning()}`
      } else {
        this.minErrorMessage = ""
      }
    }
  },
  methods: {
    onInput(event) {
      // Emette l'input per aggiornare il v-model del componente genitore
      if (event || event === "") {
        this.$emit("input", event)
      }
    },
    handleNumericInput(event) {
      // Permetti sempre le operazioni di cancellazione
      if (event.inputType && event.inputType.startsWith("delete")) {
        return
      }

      const currentValue = event.target.value
      const selectionStart = event.target.selectionStart
      const selectionEnd = event.target.selectionEnd

      // Se il primo carattere è "0" e non è presente la virgola, blocca l'inserimento (eccetto se si inserisce la virgola)
      if (
        currentValue &&
        currentValue[0] === "0" &&
        !currentValue.includes(",") &&
        selectionStart > 0
      ) {
        if (event.data !== ",") {
          event.preventDefault()
          return
        }
      }

      // Gestione degli spazi e degli inserimenti da incolla
      if (
        event.inputType === "insertText" ||
        event.inputType === "insertFromPaste"
      ) {
        if (event.data && event.data.includes(" ")) {
          event.preventDefault()
          return
        }

        // Gestione della virgola (o punto) come separatore decimale
        if (event.data === "," || event.data === ".") {
          // Se il campo è impostato per interi, blocca l'inserimento della virgola
          if (this.int) {
            event.preventDefault()
            return
          }
          // Se la virgola è già presente, blocca l'inserimento
          if (currentValue.includes(",")) {
            event.preventDefault()
            return
          }
          // Se il carattere viene inserito in prima posizione, aggiungi uno zero davanti
          if (selectionStart === 0) {
            event.target.value = "0" + currentValue
            event.preventDefault()
            return
          }
          // Se il valore attuale raggiunge il massimo, blocca l'inserimento
          if (this.max !== null && Number(currentValue) >= this.max) {
            event.preventDefault()
            return
          }
          // Blocca il punto, permettendo solo la virgola
          if (event.data === ".") {
            event.preventDefault()
            return
          }
          return // Consenti l'inserimento della virgola
        }

        // Prevenzione dell'inserimento di ulteriori zeri in prima posizione
        if (event.data === "0") {
          if (
            selectionStart === 0 &&
            currentValue.length > 0 &&
            (!this.int || currentValue[0] !== ",")
          ) {
            event.preventDefault()
            return
          }
        }

        // Verifica che l'input sia un numero
        if (isNaN(event.data)) {
          event.preventDefault()
          return
        }

        // Calcola il nuovo valore basandosi sulla posizione del cursore
        const newValue =
          currentValue.slice(0, selectionStart) +
          event.data +
          currentValue.slice(selectionEnd)

        // Limita a un massimo di 3 cifre decimali
        const parts = newValue.split(",")
        if (parts.length > 1 && parts[1].length > 3) {
          event.preventDefault()
          return
        }

        // Verifica il valore massimo, se specificato
        const numericValue = Number(newValue.replace(",", "."))
        if (this.max !== null && numericValue > this.max) {
          event.preventDefault()
        }
      }
    },
    getMinWarning() {
      //se min è diverso da null ed è un multiplo di 10, restituisci la stringa "il valore deve essere almeno di " [numero di zeri in min+ 1] + " cifre"
      //altrimenti se non è multiplo di 10, restituisci "almeno pari a " + min
      if (this.min !== null) {
        // Check if min is a power of 10 (10, 100, 1000, etc.)
        if (this.min > 0 && Math.log10(this.min) % 1 === 0) {
          // For powers of 10, number of digits is log10(min) + 1
          const digits = Math.floor(Math.log10(this.min)) + 1
          return `di ${digits} cifre`
        } else {
          // For any other value
          return `pari a ${this.min}`
        }
      } else {
        // If min is null
        return ""
      }
    }
  }
}
</script>
